import { render, staticRenderFns } from "./CustomerOrderHistory.vue?vue&type=template&id=6990b735"
import script from "./CustomerOrderHistory.vue?vue&type=script&lang=js"
export * from "./CustomerOrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports